module.exports = "img/flags/KZ.c105dab.png";